export default function scrollToFaq() {
  const path = window.location.href;
  if (path.includes('/faq/')) {
    const parts = path.split('/');
    const slug = parts[parts.length - 1];
    const faq = document.getElementById(slug);
    if (faq) {
      faq.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
